/* eslint-disable wrap-iife */
// TODO Add options in eslintrc.json accoding to 'https://eslint.org/docs/rules/wrap-iife'
( function() {
  const SEL = {
    formWrapper: '.js-cbcf',
    formEnter: '.js-cbcf-enter',
    formBranch: '.js-cbcf-option-',
    radioInput: 'input[type="radio"]',
    nextButton: '.cf7mls_next',
    responseOutput: '.wpcf7-response-output',
    responseOutputTip: '.wpcf7-not-valid-tip',
    previousStep: '.cf7mls_back_fs',
    invalidStep: '.cf7mls-invalid',
    chatWindow: '.cbcf-message-list',
    chatWindowLabel: '.cbcf-area-choosing',
    chatInput: '.wpcf7-form-control',
    currentFieldset: '.cf7mls_current_fs',
    chatInputWrapper: '.wpcf7-form-control-wrap',
    areaForm: '.cbcf-form',
    closeButton: '.cbcf-chat-close',
    openButton: '.cbcf-chat-open',
    submitButton: '.wpcf7-submit',
    hideElem: 'cbcf-hide-elem',
    showElem: 'cbcf-show-elem',
  };

  const CONST = {
    animationDelay: 1000,
    showTextDelay: 1100,
  };

  const formEnter = document.querySelector( SEL.formEnter );
  const formWrapper = document.querySelector( SEL.formWrapper );
  window.dataLayer = window.dataLayer || [];
  let stepObserver;

  const chatWindow = formWrapper.querySelector( SEL.chatWindow );
  const chatWindowLabel = chatWindow.querySelectorAll( SEL.chatWindowLabel );

  let isActive = false;

  const isMobile = ( () => {
    const ua = window.navigator.userAgent;
    if ( /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test( ua ) ) {
      return true;
    }
    return false;
  } )();

  // Open chat
  const civilleChatbotOpen = document.querySelector( SEL.openButton );
  if ( civilleChatbotOpen ) {
    civilleChatbotOpen.addEventListener( 'click', function( e ) {
      formWrapper.classList.add( 'cbcf-open' );
      civilleChatbotOpen.style.display = 'none';
      triggerInteractionEvent( e ); // analytics
    } );
  }

  // Close chat
  const civilleChatbotClose = document.querySelector( SEL.closeButton );
  if ( civilleChatbotClose ) {
    civilleChatbotClose.addEventListener( 'click', function() {
      formWrapper.classList.remove( 'cbcf-open' );
      civilleChatbotOpen.style.display = 'flex';
    } );
  }

  // handle first step
  if ( formEnter.querySelector( SEL.nextButton ) ) {
    formEnter.querySelector( SEL.nextButton ).addEventListener( 'click', function( e ) {
      const area = Array.from( formEnter.querySelectorAll( SEL.radioInput ) ).reduce( function( value, el ) {
        return el.checked ? el.value.replace( /\s/, '-' ).toLowerCase() : value;
      }, '' );

      e.stopImmediatePropagation(); // prevent default plugin logic
      triggerInteractionEvent();
      formEnter.classList.add( SEL.hideElem );
      document.querySelector( `${ SEL.formBranch }${ area }` ).classList.add( SEL.showElem );
    } );
  }

  // analytics
  function triggerInteractionEvent( e ) {
    if ( ! e.target.classList.contains( 'js-interacted' ) ) {
      /* eslint-disable quote-props */ // Recomendations from https://developers.google.com/tag-platform/tag-manager/web/datalayer
      window.dataLayer.push( {
        'event': 'cbcf-form__start',
      } );
      e.target.classList.add( 'js-interacted' );
    }
  }

  function getStepEvent( fieldset ) {
    if ( fieldset ) {
      const stepValue = fieldset.querySelector( 'label' )?.textContent.trim();
      const stepNumber = parseInt( fieldset.dataset.cf7mlsOrder ?? 400, 10 ); // If fieldset has no dataset return 400 (Like a bad request) to see error and stepNumber will 400++
      window.dataLayer.push( {
        'event': 'cbcf-form__step-done',
        'stepNumber': stepNumber + 1,
        'stepTitle': stepValue,
      } );
    }
  }

  function getFormSelection( radioButton ) {
    window.dataLayer.push( {
      'event': 'cbcf-form__form-selection',
      'selectedFormTitle': radioButton.value,
    } );
  }

  // observe step change on success validation
  function handleStepDoneEvent( e ) {
    if ( stepObserver ) {
      stepObserver.disconnect();
    }

    const currentFieldset = e.target.closest( 'fieldset' );

    // prevent empty field processing
    const currentInput = currentFieldset.querySelector( SEL.chatInput );
    if ( currentInput.value === '' ) {
      return;
    }

    const currentInputWrapper = currentFieldset.querySelector( SEL.chatInputWrapper );

    /* eslint-disable no-undef */
    stepObserver = new MutationObserver( function() {
      if ( currentFieldset.classList.contains( SEL.previousStep.substring( 1 ) ) ) {
        renderAnswerAndNextLabel( currentFieldset ); // Render answer and next label like a chat message
        focusNextField( currentFieldset ); // Make focus on next input field
        getLastMessage( currentFieldset );// Check if field have submit button add to them eventListener and also add submit and mailsend eventListeners on form
        getStepEvent( currentFieldset ); // Get analytic for GTM
        stepObserver.disconnect();
      }
    } );

    stepObserver.observe( currentFieldset, {
      attributes: true,
      attributeFilter: [ 'class' ],
      childList: false,
      characterData: false,
    } );

    stepValidationObserver = new MutationObserver( function() {
      if ( currentInputWrapper.classList.contains( SEL.invalidStep.substring( 1 ) ) ) {
        renderValidationError( currentFieldset );
        stepValidationObserver.disconnect();
      }
    } );

    if ( stepValidationObserver ) {
      stepValidationObserver.disconnect();
    }

    stepValidationObserver.observe( currentInputWrapper, {
      attributes: true,
      attributeFilter: [ 'class' ],
      childList: false,
      characterData: false,
    } );
  }

  // Render function
  function renderAnswerAndNextLabel( fieldset ) {
    // Render answer
    const currentFieldInput = fieldset.querySelector( SEL.chatInput );
    // Check if it is radio button. Render for radio buttons is added in another place
    const isRadio = currentFieldInput.classList.contains( 'wpcf7-radio' );
    const isCheckbox = currentFieldInput.classList.contains( 'wpcf7-checkbox' );
    if ( currentFieldInput.value !== '' && ! isRadio && ! isCheckbox ) {
      chatWindow.insertAdjacentHTML( 'beforeend', `<p class="cbcf-user-message cbcf-user-message-number-${ fieldset.dataset.cf7mlsOrder }">${ currentFieldInput.value }</p>` );
      scrollChatWindow();
    }

    if ( isCheckbox ) {
      const currentFieldCheckboxInputs = fieldset.querySelectorAll( SEL.chatInput + '.wpcf7-checkbox input' );
      let checkedValues = [];
      currentFieldCheckboxInputs.forEach( ( checkbox ) => {
        if ( checkbox.checked ) {
          checkedValues.push( checkbox.value );
        }
      } );
      checkedValues = checkedValues.join( ', ' ) || 'None';
      chatWindow.insertAdjacentHTML( 'beforeend', `<p class="cbcf-user-message cbcf-user-message-number-${ fieldset.dataset.cf7mlsOrder }">${ checkedValues }</p>` );
      scrollChatWindow();
    }
    // Render next label
    if ( fieldset.nextSibling !== null ) {
      const nextLabel = fieldset.nextSibling.querySelector( 'label' );
      const nextButton = fieldset.nextSibling.querySelector( SEL.nextButton );
      const nextInput = fieldset.nextSibling.querySelector( SEL.chatInput );
      const nextSubmit = fieldset.nextSibling.querySelector( SEL.submitButton );
      getTypingAnimation();
      setTimeout( () => {
        getEventListener( nextInput, nextButton );
        if ( nextSubmit ) {
          nextSubmit.addEventListener( 'click', handleStepDoneEvent, { once: true } );
        }
        chatWindow.insertAdjacentHTML( 'beforeend', `<p class="cbcf-bot-message cbcf-bot-message-number-${ fieldset.dataset.cf7mlsOrder }">${ nextLabel.textContent }</p>` );
        scrollChatWindow();
      }, CONST.showTextDelay );
    }
  }

  // Render validation error
  function renderValidationError( fieldset ) {
    if ( isActive === false ) {
      isActive = true;
      const validationErrorTip = fieldset.querySelector( SEL.responseOutputTip );
      const currentButton = fieldset.querySelector( SEL.nextButton );
      const currentInput = fieldset.querySelector( SEL.chatInput );
      getEventListener( currentInput, currentButton );
      if ( currentInput.value !== '' ) {
        getTypingAnimation();
        setTimeout( () => {
          chatWindow.insertAdjacentHTML( 'beforeend', `
            <p class="cbcf-bot-message cbcf-bot-message-number-${ fieldset.dataset.cf7mlsOrder } cbcf-error-message">
                <small><i>${ validationErrorTip.textContent }</i></small>
            </p>`
          );
          scrollChatWindow();
          isActive = false;
        }, CONST.showTextDelay );
      }
    }
  }

  // Typing animation. If isLastMessage is true, this animation will be active while status is pending.
  function getTypingAnimation( isLastMessage = false ) {
    chatWindow.insertAdjacentHTML( 'beforeend', `<p class="cbcf-bot-message typing"><span class="dot"></span><span class="dot"></span><span class="dot"></span></p>` );
    const typingAnimation = chatWindow.querySelector( '.typing' );
    const currentFieldset = formWrapper.querySelector( SEL.currentFieldset );
    const currentInput = currentFieldset.querySelector( SEL.chatInput );
    const currentButton = currentFieldset.querySelector( SEL.nextButton );
    const currentSubmitButton = currentFieldset.querySelector( SEL.submitButton );
    if ( currentInput ) {
      currentInput.setAttribute( 'readonly', 'readonly' );
    }
    if ( currentButton ) {
      currentButton.disabled = true;
    }
    if ( currentSubmitButton ) {
      currentSubmitButton.disabled = true;
    }
    if ( isLastMessage === true ) {
      // Do something if this is a final message
    } else {
      setTimeout( () => {
        if ( currentInput ) {
          currentInput.removeAttribute( 'readonly' );
        }
        if ( currentButton ) {
          currentButton.disabled = false;
        }
        if ( currentSubmitButton ) {
          currentSubmitButton.disabled = false;
        }
      }, CONST.showTextDelay );
      setTimeout( () => {
        typingAnimation.remove();
      }, CONST.animationDelay );
    }
    scrollChatWindow();
  }

  // Focus next field
  function focusNextField( currentField ) {
    if ( currentField.nextSibling && isMobile === false ) {
      setTimeout( () => {
        currentField.nextSibling.querySelector( SEL.chatInput )?.focus();
      }, CONST.showTextDelay );
    }
  }

  // Event listener next field
  function getEventListener( input, button ) {
    if ( input ) {
      input.addEventListener( 'keypress', function( e ) {
        if ( e.key === 'Enter' ) {
          handleStepDoneEvent( e );
          if ( input.value !== '' ) {
            e.stopPropagation();
          }
        }
      } );
    }
    if ( button ) {
      button.addEventListener( 'click', handleStepDoneEvent, { once: true } );
    }
  }

  // Auto-scroll to the bottom
  function scrollChatWindow() {
    chatWindow.scrollTop = chatWindow.scrollHeight;
  }

  // Add cf7 events to form on last step and render messages depending on the event
  function addCf7EventListenerAndRenderMessages( cf7Event, form, inputField, button ) {
    form.addEventListener( cf7Event, function( e ) {
      if ( isActive === true ) {
        e.stopPropagation();
      } else if ( inputField && inputField.value !== '' ) {
        isActive = true;
        // Disable input field and submit button
        inputField.setAttribute( 'readonly', 'readonly' );
        button.disabled = true;
        // Render user's message
        const userMessage = inputField.value;
        setTimeout( () => {
          chatWindow.insertAdjacentHTML( 'beforeend', `<p class="cbcf-user-message ${ cf7Event }">${ userMessage }</p>` );
          scrollChatWindow();
        }, 100 );
        const afterSubmitOutput = form.querySelector( SEL.responseOutput ); // Get output message from CF7
        setTimeout( () => {
          if ( afterSubmitOutput && afterSubmitOutput.textContent !== '' ) {
            getTypingAnimation();
            setTimeout( () => {
              chatWindow.insertAdjacentHTML( 'beforeend', `<p class="cbcf-bot-message">${ afterSubmitOutput.textContent }</p>` );
              scrollChatWindow();
              // If event is 'wpcf7mailsent' we hide input, it's the last iteration of the chat
              if ( cf7Event === 'wpcf7mailsent' ) {
                form.classList.add( SEL.hideElem );
                dataLayer.push( {
                  'event': 'cbcf-form__mail-sent', // Get analytic for GTM
                } );
                // If event is 'wpcf7invalid', 'wpcf7spam' or 'wpcf7mailfailed' we remove disabling from input field and button and clear the input value.
              } else {
                dataLayer.push( {
                  'event': `cbcf-form__${ cf7Event }`, // Get analytic for GTM
                } );
                inputField.removeAttribute( 'readonly' );
                button.disabled = false;
                inputField.value = '';
                isActive = false;
              }
            }, CONST.showTextDelay );
          }
        }, 100 );
      }
    }, false );
  }

  // Form last message event listener
  function getLastMessage( fieldset ) {
    const currentFieldset = fieldset.nextSibling;
    const submitButton = currentFieldset.querySelector( SEL.submitButton );
    if ( submitButton ) {
      submitButton.value = '';
      const lastInput = currentFieldset.querySelector( SEL.chatInput );
      const currentForm = currentFieldset.closest( 'form' );

      // Display typing animation on submit process started..
      currentForm.addEventListener( 'submit', () => {
        getTypingAnimation( true );
      } );
      // .. and remove typing animation when feedback get status
      currentForm.addEventListener( 'wpcf7submit', () => {
        const typingAnimation = chatWindow.querySelector( '.typing' );
        typingAnimation.remove();
      } );

      addCf7EventListenerAndRenderMessages( 'wpcf7invalid', currentForm, lastInput, submitButton );
      addCf7EventListenerAndRenderMessages( 'wpcf7mailsent', currentForm, lastInput, submitButton );
      addCf7EventListenerAndRenderMessages( 'wpcf7spam', currentForm, lastInput, submitButton );
      addCf7EventListenerAndRenderMessages( 'wpcf7mailfailed', currentForm, lastInput, submitButton );
    }
  }

  // Choose the form with radio buttons
  chatWindowLabel.forEach( ( radioButton ) => {
    const chatWindowRadio = radioButton.querySelector( SEL.radioInput );
    radioButton.onclick = function( event ) {
      if ( chatWindowRadio.checked ) {
        const showedForm = formWrapper.querySelector( `${ SEL.formBranch }${ chatWindowRadio.value }` );
        const allForms = formWrapper.querySelectorAll( SEL.areaForm );
        const showedFieldsets = showedForm.querySelectorAll( 'fieldset' );
        getFormSelection( chatWindowRadio ); // Get analytic for GTM

        // Show current form
        allForms.forEach( ( form ) => {
          form.classList.add( SEL.hideElem );
        } );
        showedForm.classList.remove( SEL.hideElem );
        showedForm.classList.add( SEL.showElem );

        // Disable radio buttons after pick
        const chatWindowRadios = formWrapper.querySelectorAll( SEL.chatWindowLabel );
        chatWindowRadios.forEach( ( label ) => {
          const radio = label.querySelector( SEL.radioInput );
          radio.disabled = true;
          label.setAttribute( 'disabled', 'disabled' );
          label.style.cursor = 'not-allowed';
        } );

        // Find all radio button rendered by cf7
        showedForm.querySelectorAll( '.wpcf7-radio input[type="radio"]' ).forEach( ( radio ) => {
          const fieldset = radio.closest( 'fieldset' );
          if ( ! fieldset.classList.contains( 'cbcf-checkbox-bg' ) ) {
            fieldset.classList.add( 'cbcf-radio-fieldset' );
          }
          radio.addEventListener( 'click', ( e ) => {
            radio.checked = true;
            radio.nextSibling.classList.add( 'cbcf-picked-radio' );
            const currentFieldset = radio.closest( 'fieldset' );
            // Render radio btn message.
            chatWindow.insertAdjacentHTML( 'beforeend', `<p class="cbcf-user-message cbcf-user-message-number-${ fieldset.dataset.cf7mlsOrder }">${ radio.value }</p>` );
            scrollChatWindow();
            handleStepDoneEvent( e );

            // Trigger next step on radio selection:
            currentFieldset.querySelector( '.cf7mls_next' )?.click();

            // Disable nearest radio btn and add disabling styles to picked button because if you disable picked btn MSF event doesn't fire.
            currentFieldset.querySelectorAll( '.wpcf7-list-item-label' )?.forEach( ( radioBtn ) => {
              if ( ! radioBtn.classList.contains( 'cbcf-picked-radio' ) ) {
                radioBtn.closest( 'label' ).querySelector( 'input[type="radio"]' ).disabled = true;
                radioBtn.classList.add( 'cbcf-disabled-radio' );
              }
            } );
          }, { once: true } );
        } );

        // Find all checkbox button rendered by cf7
        showedForm.querySelectorAll( '.wpcf7-checkbox' ).forEach( ( checkbox ) => {
          const fieldset = checkbox.closest( 'fieldset' );
          fieldset.classList.add( 'cbcf-checkbox-fieldset' );
        } );

        // Render first label
        showedFieldsets.forEach( ( fieldset ) => {
          if ( parseInt( fieldset.dataset.cf7mlsOrder, 10 ) === 0 ) {
            const currentLabel = fieldset.querySelector( 'label' );
            const currentInput = fieldset.querySelector( SEL.chatInput );
            const currentButton = fieldset.querySelector( SEL.nextButton );
            if ( currentInput ) {
              currentInput.setAttribute( 'readonly', 'readonly' );
              currentInput.addEventListener( 'keypress', function( e ) {
                if ( e.key === 'Enter' ) {
                  handleStepDoneEvent( e );
                  if ( currentInput.value !== '' ) {
                    e.stopPropagation();
                  }
                }
              } );
            }
            if ( currentButton ) {
              currentButton.disabled = true;
              currentButton.addEventListener( 'click', handleStepDoneEvent, { once: true } );
            }
            setTimeout( () => {
              if ( currentInput ) {
                currentInput.removeAttribute( 'readonly' );
              }
              if ( currentButton ) {
                currentButton.disabled = false;
              }
              if ( isMobile === false ) {
                fieldset.querySelector( SEL.chatInput ).focus();
              }
            }, CONST.showTextDelay );
            chatWindow.insertAdjacentHTML( 'beforeend', `<p class="cbcf-user-message">${ chatWindowRadio.closest( 'label' ).querySelector( 'span' ).textContent }</p>` );
            getTypingAnimation();
            setTimeout( () => {
              chatWindow.insertAdjacentHTML( 'beforeend', `<p class="cbcf-bot-message">${ currentLabel.textContent }</p>` );
              scrollChatWindow();
            }, CONST.showTextDelay );
          }
        } );
        event.currentTarget.onclick = null;
      }
    };
  } );
} )();
